import { useEffect } from 'react'
import type { AuditTrailStep } from './types'
import { useAuditTrailStoreSelectors } from './use-audit-trail-store'

export function useAutoSetAuditTrailStep({ page }: { page: AuditTrailStep }) {
  const { step, setStep, stepSelectionMode } = useAuditTrailStoreSelectors()

  useEffect(() => {
    if (stepSelectionMode === 'auto' && step !== page) {
      setStep(page)
    }
  }, [page, setStep, stepSelectionMode, step])
}
